import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ChartGridDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-grid-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 18h8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 20v1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 3v1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 20v1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 10v-7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3v18"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 8v8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 12h13"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 6h-1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 6h-13"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 18h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 18h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 14v2"
    }, null), _createTextVNode(" ")]);
  }
};